import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-digital-infrastructure-and-bs-pro-mng',
    templateUrl: './digital-infrastructure-and-bs-pro-mng.component.html',
    styleUrls: ['./digital-infrastructure-and-bs-pro-mng.component.scss'],
    standalone: false
})
export class DigitalInfrastructureAndBsProMngComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
